import { render } from "./AttachmentsCard.vue?vue&type=template&id=5baa1bdb&ts=true"
import script from "./AttachmentsCard.vue?vue&type=script&lang=ts"
export * from "./AttachmentsCard.vue?vue&type=script&lang=ts"

import "./AttachmentsCard.vue?vue&type=style&index=0&id=5baa1bdb&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__